import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from '@/router/beforeEach'
/**/
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Signup from '@/views/Signup.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import PasswordReset from '@/views/PasswordReset.vue'
import PasswordChange from "@/views/PasswordChange.vue";
import PoliciesPrivacy from '@/views/policies/PoliciesPrivacy.vue'
import TermsConditions from '@/views/policies/TermsConditions.vue'
import Maintenance from '@/views/Maintenance.vue'
import NotFound from '@/views/NotFound.vue'
/**/
import FlightsSearch from '@/views/flights/search'
import FlightsDetails from '@/views/flight/details/index'
import HotelsList from '@/views/hotel/List.vue'
import HotelsDetails from '@/views/hotel/details/index'
import CarsList from '@/views/cars/List.vue'
import CarsDetails from '@/views/car/details/index'
import Travel from '@/views/travel/index'
import Checkout from '@/views/checkout/index'
/**/
import Reserve from '@/views/Reserve.vue'
import MyAccount from '@/views/MyAccount.vue'
import Company from '@/views/Company.vue'
import CardsList from '@/views/CardsList.vue'
import Cards from '@/views/Cards.vue'
import TravelersList from '@/views/TravelersList.vue'
import Travelers from '@/views/Travelers.vue'
import TravelersListDependent from '@/views/TravelersListDependent.vue'
import TravelersDependent from '@/views/TravelersDependent.vue'
import Orders from '@/views/Orders.vue'
import OrderDetails from '@/views/OrderDetails.vue'
import PaymentPartialSuccess from '@/views/PaymentPartialSuccess.vue'
import PaymentSuccess from '@/views/PaymentSuccess.vue'
import PaymentApproval from '@/views/PaymentApproval.vue'
import PaymentDisapproved from '@/views/PaymentDisapproved.vue'
import PaymentError from '@/views/PaymentError.vue'
import UnexpectedError from '@/views/UnexpectedError.vue'
import Reports from '@/views/Reports.vue'
/* Admin's dashboard */
import dashboard from '@/router/dashboard'

const appTitle = process.env.VUE_APP_TITLE
Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
      path: '*',
      name: 'notFound',
      component: NotFound,
      meta: {
        title: 'Página não encontrada'
      }
    },{
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
        title: `Home | ${appTitle} - Agência online de viagens a negócios`,
        selectedTab: 'hotel'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        hideHeader: true,
        title: `Login | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/signup/:empresa',
      name: 'signup',
      component: Signup,
      meta: {
        hideHeader: true,
        title: `Signup | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      component: ForgotPassword,
      meta: {
        hideHeader: true,
        title: `Esqueci minha senha | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/password_reset',
      name: 'password_reset',
      component: PasswordReset,
      meta: {
        hideHeader: true,
        title: `Alterar senha | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/password_change',
      name: 'password_change',
      component: PasswordChange,
      meta: {
        hideHeader: true,
        title: `Alterar senha | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    /**/
    {
      path: '/flights/search/:origin/:destination/:adults/:children/:infants/:outbound/:inbound?',
      name: 'flightslist',
      component: FlightsSearch,
      meta: {
        requiresAuth: true,
        title: `Passagens | ${appTitle} - Agência online de viagens a negócios`,
        selectedTab: 'flight'
      }
    },
    {
      path: '/flights/details/:hash/:slug',
      name: 'flightdetails',
      component: FlightsDetails,
      meta: {
        requiresAuth: true,
        title: `Passagens | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/hotels/search/:dt_start/:dt_end/:city/:iata_code?/:room/:adults/:destination?',
      name: 'hotelslist',
      component: HotelsList,
      meta: {
        requiresAuth: true,
        title: `Hotéis | ${appTitle} - Agência online de viagens a negócios`,
        selectedTab: 'hotel'
      }
    },
    {
      path: '/hotels/details/:hash/',
      name: 'hoteldetails',
      component: HotelsDetails,
      meta: {
        requiresAuth: true,
        title: `Detalhes de hotel | ${appTitle} - Agência online de viagens a negócios`,
        selectedTab: 'hotel'
      }
    },
    {
      path: '/cars/search/:pickup_location/:delivery_location/:datetime_start/:datetime_end?',
      name: 'carslist',
      component: CarsList,
      meta: {
        requiresAuth: true,
        title: `Carros | ${appTitle} - Agência online de viagens a negócios`,
        selectedTab: 'car'
      }
    },
    {
      path: '/cars/details/:hash/:vehicle_id',
      name: 'cardetails',
      component: CarsDetails,
      meta: {
        requiresAuth: true,
        title: `Carros | ${appTitle} - Agência online de viagens a negócios`,
      }
    },
    {
      path: '/travel',
      name: 'travel',
      component: Travel,
      meta: {
        requiresAuth: true,
        title: `Viagem | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout,
      meta: {
        requiresAuth: true,
        title: `Checkout | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    /**/
    {
      path: '/reserve',
      name: 'reserve',
      component: Reserve,
      meta: {
        requiresAuth: true,
        title: `Pedidos | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/paymentpartialsuccess',
      name: 'paymentpartialsuccess',
      component: PaymentPartialSuccess,
      meta: {
        requiresAuth: true,
        title: `Pagamento efetuado com sucesso | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/paymentsuccess',
      name: 'paymentsuccess',
      component: PaymentSuccess,
      meta: {
        requiresAuth: true,
        title: `Pagamento efetuado com sucesso | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/paymentapproval',
      name: 'paymentapproval',
      component: PaymentApproval,
      meta: {
        requiresAuth: true,
        title: `Pagamento sob Análise de Crédito | ${appTitle} - Agência online de viagens a negócios`
      },
    },
    {
      path: '/paymentdisapproved',
      name: 'paymentdisapproved',
      component: PaymentDisapproved,
      meta: {
        requiresAuth: true,
        title: `Pedido não Aprovado | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/paymenterror',
      name: 'paymenterror',
      component: PaymentError,
      meta: {
        requiresAuth: true,
        title: `Pedido Cancelado | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    /**/
    {
      path: '/myaccount',
      name: 'myaccount',
      component: MyAccount,
      meta: {
        requiresAuth: true,
        title: `Minha conta | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/company',
      name: 'company',
      component: Company,
      meta: {
        requiresAuth: true,
        title: `Empresa | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/cards',
      name: 'cards',
      component: CardsList,
      meta: {
        requiresAuth: true,
        title: `Cartões | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/cards/add',
      name: 'add_cards',
      component: Cards,
      meta: {
        requiresAuth: true,
        title: `Adicionar cartão | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/travelers',
      name: 'travelers',
      component: TravelersList,
      meta: {
        requiresAuth: true,
        title: `Titulares | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/add-traveler',
      name: 'add-traveler',
      component: Travelers,
      meta: {
        requiresAuth: true,
        title: `Adicionar titular | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/travelers/:id',
      name: 'edit-traveler',
      component: Travelers,
      meta: {
        requiresAuth: true,
        title: `Titulares | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/travelersdependent',
      name: 'travelersdependent',
      component: TravelersListDependent,
      meta: {
        requiresAuth: true,
        title: `Viajantes Dependentes | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/add-travelerdependent',
      name: 'add-travelerdependent',
      component: TravelersDependent,
      meta: {
        requiresAuth: true,
        title: `Adicionar viajante dependente | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/travelersdependent/:id',
      name: 'edit-travelerdependent',
      component: TravelersDependent,
      meta: {
        requiresAuth: true,
        title: `Viajantes Dependentes | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/user/orders',
      name: 'orders',
      component: Orders,
      meta: {
        requiresAuth: true,
        title: `Pedidos | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      meta: {
        requiresAuth: true,
        title: `Relatórios | ${appTitle} - Agência online de viagens a negócios`,
      }
    },
    {
      path: '/user/orders/:id',
      name: 'order_details',
      component: OrderDetails,
      meta: {
        requiresAuth: true,
        title: `Pedidos | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    /**/
    {
      path: '/PoliciesPrivacy',
      name: 'policiesprivacy',
      component: PoliciesPrivacy,
      meta: {
        requiresAuth: false,
        title: `Política de Privacidade | ${appTitle} - Agência online de viagens a negócios`,
      }
    },
    {
      path: '/TermsConditions',
      name: 'termsconditions',
      component: TermsConditions,
      meta: {
        requiresAuth: false,
        title: `Termos e condições | ${appTitle} - Agência online de viagens a negócios`,
      }
    },

    /**/
    /**
     * Admin Dashboard (Painel de Operações)
     */
    ...dashboard,
    /**/

    {
      path: '/Maintenance',
      name: 'maintenance',
      component: Maintenance,
      meta: {
        requiresAuth: false,
        title: `Manutenção | ${appTitle} - Agência online de viagens a negócios`,
      }
    },
    {
      path: '/notfound',
      name: 'norfound',
      component: NotFound,
      meta: {
        hideHeader: true,
        title: `Página não encontrada | ${appTitle} - Agência online de viagens a negócios`
      }
    },
    {
      path: '/unexpectederror',
      name: 'unexpectederror',
      component: UnexpectedError,
      meta: {
        hideHeader: true,
        title: `Erro | ${appTitle} - Agência online de viagens a negócios`
      }
    }
  ]
})

router.beforeEach(beforeEach)
export default router
